export const glosarioRequisicionEmpleo = [

    {
        "name": "tipoVacanteHeader",
        "type": "divider",
        "label": "1. Tipo de Vacante",
    },
    { "name": "cargo", "type": "select", "label": "Cargo" },
    {
        "name": "contrato",
        "type": "select",
        "label": "Tipo de Contrato",
        "options": [
            { value: 'CONTRATO FIJO MEDIO TIEMPO ROL MES' },
            { value: 'CONTRATO FIJO MEDIO TIEMPO ROL DÍA' },
            { value: 'CONTRATO FIJO ROL DIARIO' },
            { value: 'CONTRATO FIJO ROL MENSUAL' },
            { value: 'CONTRATO OBRA ROL DIARIO' },
            { value: 'CONTRATO OBRA ROL MENSUAL' },
            { value: 'CONTRATO APRENDIZAJE' },
            { value: 'CONTRATO INDEFINIDO ROL MENSUAL' },
            { value: 'CONTRATO INDEFINIDO ROL DIARIO' }
        ],
    },
    {
        "name": "tipoVacante",
        "type": "select",
        "options": [{ value: "NUEVA" }, { value: "REEMPLAZO" }, { value: "OTRO" }],
        "label": "Tipo de Vacante",
    },
    {
        "name": "tipoCargo",
        "type": "select",
        "options": [
            { value: 'NO APLICA' },
            { value: 'TECNICO' },
            { value: 'PROFESIONAL' },
            { value: 'MONC' },
            { value: 'ADMINISTRATIVO' },
        ],
        "label": "Tipo de Cargo",
    },
    {
        "name": "causaReemplazo",
        "type": "select",
        "options": [
            { value: 'OVERHAUL' },
            { value: 'REEMPLAZO INCAPACIDAD' },
            { value: 'REEMPLAZO VACACIONES' },
            { value: 'RENUNCIA' },
            { value: 'ROTACIÓN COMUNIDAD' },
            { value: 'TERMINACIÓN DE CONTRATO' },
            { value: 'ASIG. TEMPORAL' },
            { value: 'ASIG. DEFINITIVA' },
            { value: 'ARRANQUE DE CONTRATO' },
        ],
        "label": "Motivo Reemplazo",
    },
    { "name": "numeroPlazas", "type": "inputText", "label": "Número de Plazas", numeric: true, defaultValue: 1 },
    { "name": "proceso", "type": "select", "label": "Proceso/Área" },
    { "name": "trabajadorReemplazar", "type": "select", "label": "Trabajador a Reemplazar" },
    { "name": "fechaIngreso", "type": "date", "label": "Fecha Estimada de Ingreso", "disabled": true },
    {
        "name": "origenCargoHeader",
        "type": "divider",
        "label": "2. Origen Del Cargo",
    },
    { "name": "tipoContractual", "type": "select", "options": [{ value: "CONTRACTUAL" }, { value: "NO CONTRACTUAL" }], "label": "Contractual/No Contractual" },
    { "name": "tipoAdmin", "type": "select", "label": "Administrativo/Operaciones" },
    { "name": "clienteComercial", "type": "select", "label": "Cliente Comercial" },
    { "name": "itemCobro", "type": "select", "label": "Item de Cobro" },
    { "name": "codigoATA", "type": "select", "label": "Código ATA" },
    { "name": "centroCosto", "type": "select", "label": "Centro de Costos" },
    { "name": "pep", "type": "inputText", "label": "**PEP" },
    {
        "name": "condicionesLaboralesHeader",
        "type": "divider",
        "label": "3. Condiciones Laborales",
    },
    { "name": "campo", "type": "select", "label": "Campo" },
    { "name": "especialidad", "type": "select", "label": "Especialidad" },
    { "name": "tipoContrato", "type": "select", "options": [{ value: 'NO APLICA' }, { value: "FIJO", }, { value: "INDEFINIDO", }, { value: "OBRA O LABOR", }, { value: "APRENDIZAJE", }], "label": "Tipo de Contrato" },
    { "name": "descripcionObraLabor", "type": "inputTextLargo", "label": "Descripción Obra Labor" },
    { "name": "duracionContrato", "type": "inputText", "label": "Duración del Contrato en días" },
    { "name": "nomina", "type": "select", "options": [{ value: 'NO APLICA' }, { value: "LEGAL" }, { value: "CONVENCIONAL" }, { value: "ROL DÍARIO" }], "label": "NÓMINA/PLANTILLA" },
    { "name": "tipoSalario", "type": "select", "options": [{ value: 'NO APLICA' }, { value: "REMUNERACIÓN BÁSICO", }, { value: "INTEGRAL", }, { value: "JORNAL HORA", }, { value: "APOYO SOSTENIMIENTO" }], "label": "Tipo de Salario" },
    { "name": "salario", "type": "inputText", "label": "Salario/Remuneración", 'numeric': true },
    { "name": "jefeInmediato", "type": "select", "label": "Jefe Inmediato" },
    { "name": "turno", "type": "select", "label": "Turno" },
    { "name": "conductor", "type": "select", "options": [{ value: 'NO APLICA' }, { value: "SI", }, { value: "NO", },], "label": "Funciones de Conductor" },
    // { "name": "auxAlimentacion", "type": "inputText", "label": "Auxilio de Alimentación", 'numeric': true },
    // { "name": "auxLocalizacion", "type": "inputText", "label": "Auxilio de Localización", 'numeric': true },
    // { "name": "auxMovilizacion", "type": "inputText", "label": "Auxilio de Movilización", 'numeric': true },
    // { "name": "jornadaSuplementaria", "type": "inputText", "label": "Jornada Suplementaria", 'numeric': true },
    // { "name": "auxOtros", "type": "select", "label": "Otros Auxilios" },
    // { "name": "auxOtrosValue", "type": "inputText", "label": "Valor Otros Auxilios" },
    {
        "name": "auxiliosHeader",
        "type": "divider",
        "label": "3. Auxilios",
    },
    { "name": "auxilios", "type": "unique1" },
    { "name": "auxiliosDiarios", "type": "unique2" },
    // { "name": "otros", "type": "inputTextLargo", "label": "Otros" },
    { "name": "observaciones", "type": "inputTextLargo", "label": "Observaciones" },
    {
        "name": "recursosHeader",
        "type": "divider",
        "label": "4. Recursos",
    },
    { "name": "recursos", "type": "checkbox", "options": [{ value: 'NO APLICA' }, { value: 'Celular' }, { value: 'Radio' }, { value: 'Computador' }, { value: 'Vehiculo' }, { value: 'Monitor' }, { value: 'Maleta' }, { value: 'Tablet' }, { value: 'Teclado + Mouse' }] },
    {
        "name": "adjuntosHeader",
        "type": "divider",
        "label": "5. Adjuntos",
    },
]

export const glosarioOpciones = [
    {
        "name": "cargo",
        "req": "cargo",
        "urlReq": "https://cfp-backend.azurewebsites.net/api/consultaKactusCargo?code=Q7XXmdE4Lxn/1Kn9ra2fP8XaVARa38RT7Na46unkqiPP7B5GUF58XA==",
    },
    {
        "name": "trabajadorReemplazar",
        "req": "trabajador",
        "urlReq": "https://cfp-backend.azurewebsites.net/api/consultaKactusTrabajadores?code=ca8o9eBFpPsLfnJdjqg0G9N56TAA9GSmhxNvScZbMUQe1US2G8hhzw==",
    },
    {
        "name": "jefeInmediato",
        "req": "jefe",
        "urlReq": "https://cfp-backend.azurewebsites.net/api/consultaKactusTrabajadores?code=ca8o9eBFpPsLfnJdjqg0G9N56TAA9GSmhxNvScZbMUQe1US2G8hhzw==",
    },
    {
        "name": "itemCobro",
        "req": "itemCobro",
        "urlReq": "https://cfp-backend.azurewebsites.net/api/consultaKactusItemCobro?code=LDkb2KKITOqVtwV8EGUPtxqaevNLM6B9vslmkMVCN6J4K2qgrmdmNA==",
    },
    {
        "name": "codigoATA",
        "req": "codigoATA",
        "urlReq": "https://cfp-backend.azurewebsites.net/api/consultaKactusCodigoATA?code=QFULSYsWNNztJQPtc1BLQSyK0nKHUDlXnWYv1ZaSrWdbiw6rYw1nXg==",
    },
    {
        "name": "centroCosto",
        "req": "centroCostos",
        "urlReq": "https://cfp-backend.azurewebsites.net/api/consultaKactusCentroCostos?code=mglCHvENd13fXeDxJW3aOFw2AMUsbxDE9iN/CuwyYndGKIkXQbV2qg==",
    },
    {
        "name": "campo",
        "req": "campo",
        "urlReq": "https://cfp-backend.azurewebsites.net/api/consultaKactusCampo?code=BjR8gDdaBjagpyPILIj7au8Sa6Pm/fGja8O9Zb0QZ0DG635NL3hvrg==",
    },
    {
        "name": "clienteComercial",
        "req": "clienteComercial",
        "urlReq": "https://cfp-backend.azurewebsites.net/api/consultaKactusCliente?code=ZtelLeEgOxBF/WnCCSCrsXJlyanoB4ekp47DS6CYy/RaXmzkjtauew==",
    },
    {
        "name": "especialidad",
        "req": "especialidad",
        "urlReq": "https://cfp-backend.azurewebsites.net/api/consultaKactusEspecialidad?code=ME3HFQ7ilqYzW5SUhvVQWX1P7zvVNsvxKYdJD180wf4d4aIn/5D2uQ==",
    },
    {
        "name": "proceso",
        "req": "proceso",
        "urlReq": "https://cfp-backend.azurewebsites.net/api/consultaKactusProceso?code=Mrw16VxtxykD8SY7tcdDJo9awTpM5K9rJeGlZxtKAJIIvVYpkUE4Sw==",
    },
    {
        "name": "turno",
        "req": "turno",
        "urlReq": "https://cfp-backend.azurewebsites.net/api/consultaKactusTurno?code=37chn7luRgB6tPYlb5P6alFsDXdduDeCAmIyu6XVUmtXZu2kLir4VA==",
    },
]

export const glosarioProceso1 = [
    {
        "id": "SOLICITADO",
        "name": "Creador",
        "email": "emailCreador",
        "key": "nombreCreador",
        "cedula":"cedulaCreador"
    },
    {
        "id": "APROBACION1",
        "name": "Primer Aprobador",
        "email": "emailPrimerAprobador",
        "key": "nombrePrimerAprobador",
        "cedula":"cedulaPrimerAprobador"
    },
    {
        "id": "APROBACION2",
        "name": "Segundo Aprobador",
        "email": "emailSegundoAprobador",
        "key": "nombreSegundoAprobador",
        "cedula":"cedulaSegundoAprobador"
    },
    {
        "id": "APROBACION3",
        "name": "Tercer Aprobador",
        "email": "emailTercerAprobador",
        "key": "nombreTercerAprobador",
        "cedula":"cedulaTercerAprobador"
    },
    {
        "id": "APROBACION4",
        "name": "Cuarto Aprobador",
        "email": "emailCuartoAprobador",
        "key": "nombreCuartoAprobador",
        "cedula":"cedulaCuartoAprobador"
    },
    {
        "id": "RECLUTADOR",
        "name": "Reclutamiento",
        "email": "emailReclutador",
        "key": "nombreReclutador",
        "cedula":"cedulaReclutador",
        steps: [
            'RECLUTADOR',
            'VALIDACION_RECLUTADOR',
            'PUBLICACION',
            'REMISION',
            'PRUEBAS',
            'ENTREVISTA',
            'VALIDACION',
            'ESTUDIO_SEGURIDAD',
            'EXAMEN_MEDICO',
            'CONTRATACION',
            'REVISION'
        ]
    },
    {
        id: "CONTRATADOR",
        name: "Contratación",
        email: "emailContratador",
        key: "nombreContratador",
        cedula:"cedulaContratador",
        steps: [
            'CONTRATACION',
            'VERIFICACION_DOCUMENTAL',
            'SEGURIDAD_SOCIAL',
            'CONTRATACION_2',
            'CONTRATACION_3',
            'SEGURIDAD_SOCIAL',
            'INGRESO_KACTUS',
            'REPORTE_NOMINA',
            'FINALIZADO'
        ]
    },
]